// Release manifest (06 §3.1 adapted to ADR-0019: a signed tar.gz bundle of the Windows/Linux app folders,
// not container images). Signed 2-of-3 by offline release keys (09 §8, SEC-21/22/23).
import { z } from 'zod';
const semver = z.string().regex(/^\d+\.\d+\.\d+(-[0-9A-Za-z.-]+)?$/);
export const releaseManifestBodySchema = z.object({
    product: z.literal('syrova-node'),
    version: semver,
    channel: z.enum(['dev', 'staging', 'stable']),
    createdAt: z.iso.datetime(),
    /** replay/freeze guard: a node offline past this date keeps running and only warns */
    expiresAt: z.iso.datetime(),
    /** anti-rollback: nodes refuse manifests older than their current version unless `kind: 'rollback'` */
    kind: z.enum(['release', 'rollback', 'security']).default('release'),
    bundle: z.object({
        /** absolute URL or a path relative to the registry's bundle base (CDN / USB package) */
        url: z.string().min(1),
        sha256: z.string().regex(/^[0-9a-f]{64}$/),
        sizeBytes: z.number().int().positive(),
    }),
    db: z.object({
        schemaVersion: z.number().int().nonnegative(),
        /** expand-only files shipped in the bundle (packages/db/migrations/node) */
        migrations: z.array(z.string()).default([]),
        minSchemaVersionForApp: z.number().int().nonnegative(),
    }),
    compatibility: z.object({
        minUpgradeFrom: semver,
        nodeAgentMin: semver.optional(),
    }),
    preflight: z
        .object({
        minFreeDiskGb: z.number().nonnegative().default(2),
        maxBackupAgeHours: z.number().positive().default(24),
        requireNoOpenNightAudit: z.boolean().default(true),
    })
        .default({ minFreeDiskGb: 2, maxBackupAgeHours: 24, requireNoOpenNightAudit: true }),
    notesUrl: z.string().optional(),
});
export const manifestSignatureSchema = z.object({
    keyId: z.string().min(1),
    sig: z.string().min(1),
});
export const releaseManifestSchema = releaseManifestBodySchema.extend({
    signatures: z.array(manifestSignatureSchema).min(1),
});
/** Rollout plan the registry keeps per release (06 §5). */
export const rolloutPlanSchema = z.object({
    /** 0..100 — a node is included when hash(nodeId) % 100 < percent, or when listed as canary */
    percent: z.number().int().min(0).max(100).default(0),
    canaryNodeIds: z.array(z.uuid()).default([]),
    /** auto-pause when failed/attempted exceeds this share once attempts ≥ minAttempts */
    maxFailureRate: z.number().min(0).max(1).default(0.02),
    minAttempts: z.number().int().positive().default(3),
});
export const UPDATE_STATES = [
    'idle',
    'detected',
    'verifying',
    'scheduled',
    'downloading',
    'verified',
    'preflight',
    'backing_up',
    'migrating',
    'switching',
    'health_check',
    'done',
    'rolled_back',
    'failed',
    'incompatible',
];
//# sourceMappingURL=release.js.map